<template>
	<v-card class="connect_profile pa-3 px-10" height="550">
		<v-form @submit.prevent="addCname" v-model="formValid">
			<div class="flex-space-around--center flex-column text-align-center">
				<div class="my-6">
					<h1 class="big">{{ title }}</h1>
					<h1 class="med">
						Type CNAME url for
						<v-card class="ac_card inline-block">
							<div class="centerdXY">
								<SIcon :width="22" :name="app.service_slug" />
							</div>
						</v-card>
						{{ app.service_name }}
					</h1>
				</div>
				<div class="width-80">
					<h3 class="my-1 text-align-left med">
						I need information how to copy <b>CNAME</b>
						<v-tooltip right content-class="tooltip-content">
							<template v-slot:activator="{ on, attrs }">
								<span v-bind="attrs" v-on="on" class="pl-2">
									<SIcon :name="'circ-info'"></SIcon>
								</span>
							</template>
							<div>
								<v-img :src="CnameExampleImg" />
							</div>
							<div class="pt-12">
								<span class="tooltip-text"> I need information how to copy </span>
							</div>
						</v-tooltip>
					</h3>
					<v-text-field dense single-line outlined placeholder="Type CNAME url here" v-model="cname" :rules="inputRules"></v-text-field>
				</div>
				<div class="img-description pt-3 pb-2">
					<h3 class="med">
						If Ply haven't been granted permissions yet for this cname,<br />
						click <b>“Allow”</b> on the next screen to give them.
					</h3>
				</div>
				<v-img :src="instructiveImg" class="instructive-img" />
				<div class="btn_placeholder pt-2">
					<v-btn block class="ac_btn" width="166" color="#5C8DF5" height="45" type="submit" :loading="loading" :disabled="!formValid">
						Connect
					</v-btn>
				</div>
			</div>
		</v-form>
	</v-card>
</template>

<script>
import WinImg from './assets/win.png';
import MacImg from './assets/mac.png';
import CnameExampleImg from './assets/cname-example.png';
import { mapGetters } from 'vuex';
import UserAgentService from '@/utils/user-agent-service';
export default {
	name: 'AddCname',
	props: {
		app: {
			type: Object,
		},
		loading: {
			type: Boolean,
			default: false,
		},
	},
	computed: {
		...mapGetters(['account/cnames']),
		CnameExampleImg() {
			return CnameExampleImg;
		},
		title() {
			return 'Connect URL';
		},
		instructiveImg() {
			return UserAgentService.isWindows() ? WinImg : MacImg;
		},
		inputRules() {
			const cnames = this['account/cnames'][this.app.id] || [];
			return [(v) => !!v || 'Field is required', (v) => !cnames.includes(v) || 'Cname already exists'];
		},
	},
	data: () => ({
		cname: '',
		formValid: false,
	}),
	methods: {
		addCname() {
			if (this.formValid) {
				this.$emit('add-cname', { serviceId: this.app.id, cname: this.cname });
			}
		},
	},
};
</script>

<style lang="scss" scoped>
.instructive-img {
	width: 60%;
}
.img-description {
	color: #040404;
	font-size: 16px;
	font-weight: 400;
}
.btn_placeholder {
	width: 80%;
	.ac_btn {
		font-weight: 500;
		color: white;
		width: 220px;
	}
}
.ac_card {
	width: 30px;
	height: 30px;
	border-radius: 5px !important;
}
.tooltip-content {
	background: white;
	min-height: 250px;
	opacity: 1 !important; // override vuetify's default
	box-shadow: 0 5px 5px -3px rgb(0 0 0 / 20%), 0 8px 10px 1px rgb(0 0 0 / 14%), 0 3px 14px 2px rgb(0 0 0 / 12%);
	.tooltip-text {
		color: black;
	}
}
</style>
